app.directive('programSubjects', function () {
    return {
        restrict: 'E',
        replace: true,
        templateUrl: _pb + 'components/program-subjects/program-subjects.html',
        scope: {
            container: '=',
            subjectOptions: '=',
            readonly: '=',
            gela: '='
        }
    };
});